import styled from '@emotion/styled'

export const CheckboxWrapper = styled.div`
  padding: 0 30px;
`

export const EmptyTitleWrapper = styled.div`
  margin: 0 30px;
`
